/** @format */

import { Row, Col, Tooltip } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionShiftCreateRequest } from "../../../../redux-modules/actions/actionsShifts";
import { selectorLocationsList } from "../../../../redux-modules/selectors/selectorsLocations";
import { selectorShiftTypeList } from "../../../../redux-modules/selectors/selectorsShiftTypes";
import { UIInput } from "../../../ui/Input";
import UIModal from "../../../ui/Modal";
import { UISelect } from "../../../ui/Select";
import { UIText } from "../../../ui/Text";
import { UITextArea } from "../../../ui/Textarea";
import { selectorLoggedTenance } from "../../../../redux-modules/selectors/selectorsAuth";
import { UICheckbox } from "../../../ui/Checkbox";
import { InfoCircleFilled } from "@ant-design/icons";
const { Option } = UISelect;

interface Props {
  isModalVisible: boolean;
  closeModal: () => void;
  markShiftChangePending: (userId: string) => void;
  user_id: string;
  user_name: string;
  date: string;
  
}
export const AddShiftModal = ({
  isModalVisible,
  closeModal,
  markShiftChangePending,
  user_id,
  user_name,
  date,
}: Props): JSX.Element => {
  const dispatch = useDispatch();
  const shiftTypeList = useSelector(selectorShiftTypeList);
  const officeList = useSelector(selectorLocationsList);
  const [selectedShiftType, setSelectedShiftType] = useState<string>();
  const [selectedOffice, setSelectedOffice] = useState<string>();
  const [notes, setNotes] = useState<string>("");
  const tenance = useSelector(selectorLoggedTenance);

  const [isHiddenEndOfShift, setisHiddenEndOfShift] = useState(!!tenance?.default_hidden_end_of_shift);

  const handleOk = () => {
    if (selectedShiftType) {
      dispatch(
        actionShiftCreateRequest({
          user_id,
          date,
          shift_type_id: selectedShiftType,
          office_id: selectedOffice,
          hidden: isHiddenEndOfShift,
          notes: notes.trim() || undefined,
        }),
      );

      markShiftChangePending(user_id); 
    }
    closeModal();
  };

  useEffect(() => {
    if (!isModalVisible) {
      setSelectedShiftType(undefined);
      setSelectedOffice(undefined);
      setNotes("");
    }
  }, [isModalVisible]);

  return (
    <UIModal
      title={"Nuovo turno  -  " + moment(date).format("DD/MM/YYYY")}
      visible={isModalVisible}
      onOk={handleOk}
      okText="Salva"
      okButtonProps={{
        style: { borderRadius: "7px" },
      }}
      cancelButtonProps={{ style: { borderRadius: "7px" } }}
      onCancel={closeModal}
    >
      <Row style={{ marginBottom: "10px" }}>
        <Col>
          <UIText>
            Nuovo turno per l'utente <span style={{ fontWeight: 600 }}>{user_name}</span>
          </UIText>
        </Col>
      </Row>
      <Row style={{ marginBottom: "10px" }}>
        <Col span={24}>
          <Row>
            <Col>
              <UIText>Seleziona una tipologia di turno:</UIText>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <UISelect
                value={selectedShiftType}
                style={{ width: "50%" }} //@ts-ignore
                onChange={value => setSelectedShiftType(value)}
                showSearch
                filterOption={(input, option) =>
                  ((option!.children as unknown) as string)
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
              >
                {shiftTypeList.map(e => (
                  <Option key={e.id} value={e.id}>
                    { (e.name) + " " + (e.is_notturno ? "(Notturno)" : "")}
                  </Option>
                ))}
              </UISelect>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <Row>
            <Col>
              <UIText>Seleziona una sede:</UIText>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <UISelect
                showSearch
                value={selectedOffice}
                placeholder={"N/D"}
                style={{ width: "50%" }}
                //@ts-ignore
                onChange={value => setSelectedOffice(value)}
                filterOption={(input, option) =>
                  ((option!.children as unknown) as string)
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
              >
                {officeList.data.map(e => (
                  <Option key={e.id} value={e.id}>
                    {e.name}
                  </Option>
                ))}
              </UISelect>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row style={{ marginTop: "10px" }}>
        <Col span={24}>
          <Row>
            <Col>
              <UIText>Note:</UIText>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <UITextArea
                value={notes}
                onChange={e => setNotes(e.target.value)}
                placeholder="Aggiungi una nota al turno (facoltativo)"
                rows={3}
                maxLength={5000}
              />
            </Col>
          </Row>
        </Col>
      </Row>

      <Row style={{ marginTop: "15px" }}>
        <Col>
          <UIText>
            <Tooltip title="Esempio: 09:00 - FINE TURNO">
              <InfoCircleFilled style={{ marginRight: "4px" }} />
            </Tooltip>

            Nascondi fine turno
          </UIText>
          <UICheckbox
            onChange={e => setisHiddenEndOfShift(e.target.checked)}
            checked={isHiddenEndOfShift}
            style={{ marginLeft: "8px" }}
          />
        </Col>
      </Row>

    </UIModal>
  );
};
